import request from '@/utils/request.js'

// 判断当前公司是否已经注册 -- 认证时使用
export function judgeCompanyAlreadyExistedApi(params) {
  return request({
    url: `/enterprise/companies/exist`,
    method: 'get',
    params
  })
}

// 提交公司信息认证
export function approveCompanyApi(data) {
  return request(
    {
      url: `/enterprise/companies/register`,
      method: 'post',
      data
    },
    { needLoading: true }
  )
}

// 修改公司信息认证
export function editApproveCompanyApi(data) {
  return request(
    {
      url: `/enterprise/companies/certification`,
      method: 'post',
      data
    },
    { needLoading: true }
  )
}

// 获取公司的认证审核单
export function getCompanyAuditInfoApi() {
  return request({
    url: '/enterprise/companies/oneself/audits/latest',
    method: 'get'
  })
}

// 获取公司身份认证审核单
export function getServiceAuditInfoApi() {
  return request({
    url: '/enterprise/companies/oneself/service-audits/latest',
    method: 'get'
  })
}

// 当前登录账号所属的公司信息
export function getUserCompanyInfoApi() {
  return request({
    url: '/enterprise/companies/oneself',
    method: 'get'
  })
}

// 获取公司的基本联系信息
export function getCompanyConnectApi() {
  return request({
    url: '/enterprise/companies/oneself/basic-info',
    method: 'get'
  })
}

// 获取公司信息
export function getCompanyInfoApi() {
  return request({
    url: `/enterprise/companies/oneself`,
    method: 'get'
  })
}

// 获取公司的工商信息
export function getCompanyBusinessInfoApi() {
  return request({
    url: `/enterprise/companies/oneself/business-info`,
    method: 'get'
  })
}

// 根据公司名称判断公司是否存在
// 注册时使用
export function judgeCompanyRegisteredApi(params) {
  return request({
    url: '/enterprise/exist-name',
    method: 'get',
    params
  })
}

// 查询采购人或代理机构公司
export function getPurchaserOrAgencyApi(params) {
  return request({
    url: '/enterprise/companies/purchaser-or-agency/page',
    method: 'get',
    params
  })
}
